var exports = {
  "kL": "xdde3148b--835e53--container",
  "QN": "xdde3148b--835e53--company",
  "nf": "xdde3148b--835e53--link",
  "WL": "xdde3148b--835e53--factoids",
  "DY": "xdde3148b--835e53--reliable",
  "WT": "xdde3148b--835e53--escrow-block",
  "iE": "xdde3148b--835e53--wrapper",
};

module.exports = exports;
